var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerified = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 19 18",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2E90FA",
  d: "M14.4 3.188c.171.413.5.742.912.913l1.45.6a1.69 1.69 0 0 1 .912 2.205l-.6 1.448a1.69 1.69 0 0 0 .001 1.292l.599 1.448a1.687 1.687 0 0 1-.914 2.205l-1.447.6c-.414.17-.743.499-.914.912l-.6 1.449a1.687 1.687 0 0 1-2.205.913l-1.448-.6a1.7 1.7 0 0 0-1.291.002l-1.449.599a1.687 1.687 0 0 1-2.203-.913l-.6-1.45a1.69 1.69 0 0 0-.913-.913l-1.449-.6a1.69 1.69 0 0 1-.914-2.204l.6-1.448c.17-.413.17-.878 0-1.29l-.6-1.45A1.687 1.687 0 0 1 2.241 4.7l1.448-.6c.413-.17.741-.498.913-.911l.6-1.449A1.69 1.69 0 0 1 7.407.827l1.448.6c.413.17.878.17 1.29-.002l1.45-.597a1.687 1.687 0 0 1 2.205.913l.6 1.45z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.744 6.298a.845.845 0 0 0-1.425-.907l-3.304 5.192-1.512-1.89a.844.844 0 0 0-1.318 1.054l2.25 2.812a.843.843 0 0 0 1.371-.074z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verified.f6b8a898da2eafe3ffe4ec9ba0c66c65.svg";